import { render, staticRenderFns } from "./FormatoArquivo.vue?vue&type=template&id=40de2f62&scoped=true"
import script from "./FormatoArquivo.vue?vue&type=script&lang=js"
export * from "./FormatoArquivo.vue?vue&type=script&lang=js"
import style0 from "./FormatoArquivo.vue?vue&type=style&index=0&id=40de2f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40de2f62",
  null
  
)

export default component.exports